import { useTranslation } from "react-i18next";

/**
 * Brand-neutral loading screen rendered by BrandingProvider while the by-slug
 * fetch is in flight on a branded subdomain. Brand-neutral palette
 * (var(--background)), CSS-keyframe spinner, ARIA-live status announcement.
 * Unmounted by BrandingProvider when the fetch settles OR by the 3 s ceiling.
 */
export function BrandHydrationFallback() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: "hsl(var(--background))",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      data-testid="brand-hydration-fallback"
    >
      <span
        aria-hidden="true"
        className="gci-brand-hydration-spinner"
        style={{
          width: "32px",
          height: "32px",
          border: "3px solid hsl(var(--muted))",
          borderTopColor: "hsl(var(--muted-foreground))",
          borderRadius: "50%",
        }}
      />
      <span style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)" }}>
        {t("branding.hydration.loading")}
      </span>
      <style>{`
        @keyframes gci-brand-hydration-spin { to { transform: rotate(360deg); } }
        /* # WHY honor user motion preferences — the form-app's MotionConfig (App.tsx)
           sets reducedMotion="user" globally; this inline keyframe needs its own
           media-query gate because the @keyframes runs outside framer-motion's
           reduced-motion plumbing. */
        @media (prefers-reduced-motion: no-preference) {
          .gci-brand-hydration-spinner { animation: gci-brand-hydration-spin 0.9s linear infinite; }
        }
      `}</style>
    </div>
  );
}
